<template>
  <div class="page-view">
    <!-- 头部内容 -->
    <div class="page-header">
      <!-- 面包屑 -->
      <a-breadcrumb class="page-breadcrumb">
        <a-breadcrumb-item>财务管理</a-breadcrumb-item>
        <a-breadcrumb-item>账户充值</a-breadcrumb-item>
      </a-breadcrumb>
      <!-- 金额详情 -->
      <div class="list-view">
        <!-- 账户总余额 -->
        <div class="list-item">
          <div class="list-item-title">账户总余额(元)</div>
          <div class="list-item-value">{{ totalMoney }}</div>
        </div>
        <!-- 分割线 -->
        <a-divider type="vertical" />
        <!-- 冻结金额 -->
        <div class="list-item">
          <div class="list-item-title">冻结金额(元)</div>
          <div class="list-item-value">{{ cannotMoney }}</div>
        </div>
        <!-- 分割线 -->
        <a-divider type="vertical" />
        <!-- 可用余额 -->
        <div class="list-item">
          <div class="list-item-title">可用余额(元)</div>
          <div class="list-item-value">{{ useMoney }}</div>
        </div>
        <!-- 按钮 -->
        <div class="list-item">
          <!-- 充值 -->
          <a-button type="primary" @click="touchRecharge">充值</a-button>
          <!-- 退款 -->
          <a-tooltip>
            <template slot="title">敬请期待</template>
            <a-button style="margin-left: 12px;" :disabled="true">退款</a-button>
          </a-tooltip>
        </div>
      </div>
    </div>
    <!-- 页面内容 -->
    <div class="page-content">
      <!-- 标题 -->
      <div class="page-title">充值记录</div>
      <!-- 列表 -->
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :row-key="(record) => record.id"
        :pagination="pagination"
        :loading="isLoading"
        @change="handleTableChange"
      >
        <!-- 流水类型 -->
        <template slot="flow_type">线下充值</template>
      </a-table>
    </div>
  </div>
</template>

<script>
import Pub from '@/utils/public'
import { paymentBalance, rechargeList } from '@/api/request'
// 列字段
const columns = [
  {
    title: '充值时间',
    dataIndex: 'created_date',
    key: 'created_date'
  },
  {
    title: '金额(元)',
    dataIndex: 'money',
    key: 'money'
  },
  {
    title: '充值方式',
    dataIndex: 'flow_type',
    key: 'flow_type',
    scopedSlots: { customRender: 'flow_type' }
  }
]
export default {
  data () {
    return {
      Pub,
      // 列字段
      columns,
      // 数据源
      dataSource: [],
      // 分页器
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true
      },
      isLoading: false,
      // 金额
      totalMoney: '0.00',
      useMoney: '0.00',
      cannotMoney: '0.00'
    }
  },
  created () {
    // 账户金额
    this.paymentBalance()
    // 获取充值记录
    this.rechargeList()
  },
  methods: {
    // 分页
    handleTableChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.rechargeList()
    },
    // 跳转充值页
    touchRecharge () {
      Pub.JUMP_ROUTER('/recharge-detail')
    },
    // 账户金额
    paymentBalance () {
      paymentBalance().then(res => {
        const { code, data, message } = res
        if (code === 0) {
          const totalMoney = Number(data.total_money || 0)
          const useMoney = Number(data.can_use_money || 0)
          const cannotMoney = Number(data.cannot_use_money || 0)
          this.totalMoney = Pub.KEEP_NUMBER_DECIMAL(totalMoney / 100, 2, false, true)
          this.useMoney = Pub.KEEP_NUMBER_DECIMAL(useMoney / 100, 2, false, true)
          this.cannotMoney = Pub.KEEP_NUMBER_DECIMAL(cannotMoney / 100, 2, false, true)
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.confirmLoading = false
        this.$message.error('获取可用余额失败')
      })
    },
    // 充值流水
    rechargeList () {
      this.isLoading = true
      const params = {
        page: this.pagination.current,
        page_size: this.pagination.pageSize
      }
      rechargeList(params).then(res => {
        this.isLoading = false
        const { code, data, message } = res
        if (code === 0) {
          this.dataSource = data.list.data
          this.pagination.total = data.list.total
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style>
.page-header .ant-divider-vertical {
  height: 40px;
}
</style>
<style lang="less" scoped>
.page-view {
  background-color: #F0F2F5;
  height: 100%;
}
.page-header {
  padding: 24px 32px;
  background-color: #fff;
}
.page-header .list-view {
  margin-top: 20px;
  height: 80px;
  display: flex;
  align-items: center;
}
.page-header .list-item {
  white-space: nowrap;
  padding-left: 8%;
  flex: 1;
}
.page-header .list-item:last-child {
  padding-left: 0;
}
.page-header .list-item-title {
  color: rgba(0, 0, 0, 0.43);
  line-height: 22px;
}
.page-header .list-item-value {
  font-size: 28px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 38px;
}
.page-content {
  margin-top: 24px;
  padding: 24px 32px;
  background-color: #fff;
}
.page-content .page-title {
  font-size: 16px;
  color: #333333;
  padding-bottom: 24px;
}
</style>